import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from '../../services/http.service';
import { AppConstants } from '../../app.constants';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class DataAnalyticsService {
    private firebaseUrl: string;
    private schoolId: string;
    private userId: string;
    private branchId: string;

    private token: string;
    // private childid : string = '83FCFE02-314D-4C81-881F-A0BD053AD532';
    // private testid : string = 'E148FD6F-0535-47ED-AC49-A87A5336AC89';
    // private sectionid : string = '8a09f2b1-c232-49bc-885f-13f8f89ef6ad';
    // private subjectid : string = 'd724d513-d7d2-4bd2-a451-a136a006409f';
    // private semester1 : string = '18FE22FA-1DD1-4E4A-9E0A-28567F44D758';
    // private semester2 : string = 'F060ABBA-0DE5-454F-9398-52FF78CDF5C2';
    private arr1 : number = 80 ;
    private arr2 : number = 65 ;
    private arr3 : number = 50 ;
    constructor(private httpClient: HttpClient,
                private appConstants: AppConstants, private localStorage: LocalStorageService) {
        this.firebaseUrl = this.localStorage.retrieve('Firebase');
        this.schoolId = this.localStorage.retrieve('SchoolId');
        this.branchId = this.localStorage.retrieve('BranchId');
    }

    public getClassSectionMap(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetstandardsectionMapping + '?Schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }





  // Digital report card
    public getStudentRC(StudentId,TestId,academicYearId): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getStudentsRC + '?childid=' + StudentId + '&testid=' + TestId + '&Schoolid=' + this.schoolId+ '&academicYearId=' + academicYearId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

     //posting score/comments
     public postScore(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateStudentRC;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public addGradeSection(deptPayload): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.addGradeSection;
      return this.httpClient.Post(url, deptPayload)
          .map(this.extractData)
          .catch(this.handleError)
    }

    //posting score/comments
    public postScoreHiEd(deptPayload): Observable<Response> {
       let url: string = '' + this.appConstants.baseUrl + "HiEduUpdateStudentsRc";
       return this.httpClient.Post(url, deptPayload)
           .map(this.extractData)
           .catch(this.handleError)
   }

    // Get Subjects for summary
    public getSummarySubjects(SectionId): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataASubjectsDropdown + '?sectionid=' + SectionId + '&schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    // Get Subjects
    public getSubjects(SectionId): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.subjectsWithSemestersDropdown + '?sectionid=' + SectionId + '&schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


  public getTeacherValidateSubjects(academicYearId,schoolUserId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetTeacherDetailsSubjects' + '?academicYearId=' + academicYearId + '&schoolUserId=' + schoolUserId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }


  // Get Subjects
  public getPaper(yearIdFrom,yearIdTo,gradeId,subjectId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetGeneratedQuestions' +
      '?academicYearFromId=' + yearIdFrom +
      '&academicYearToId=' + yearIdTo +
      '&gradeId=' + gradeId +
      '&subjectId=' + subjectId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }



  // Get Subjects
  public getSyllabusGenerate(yearIdFrom,yearIdTo,gradeId,subjectId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetGeneratedSyllabus' +
      '?academicYearFromId=' + yearIdFrom +
      '&academicYearToId=' + yearIdTo +
      '&gradeId=' + gradeId +
      '&subjectId=' + subjectId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }



  //get students related with parents
  public getStudentsByParentRelation(StandardId,SectionId,AcademicYear): Observable<Response> {
    this.token = this.localStorage.retrieve('token');
    let url: string = '' + this.appConstants.baseUrl + 'GetParentsListStudentView' +
      '?token=' + this.token +
      '&academicyearid=' + AcademicYear +
      '&nuofRows=' + 100 +
      '&pageNumber=' + 1 +
      '&searchstring=' + '' +
      '&standard=' + StandardId +
      '&section=' + SectionId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }



    //get students
    public getStudents(StandardId,SectionId,AcademicYear): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataAStudentsDropdowns + '?standardid=' + StandardId +  '&sectionid=' + SectionId + '&schoolid=' + this.schoolId +  '&academicYear=' + AcademicYear;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //post semester year
    public postSemesterYear(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postSemesterYear
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError);
    }



    //get semester
    public getSemesters(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSemesters + '?schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }
    //Update semester
    public updateSemesters(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UpdateSemester"
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError);
    }


    deleteStudentById(childId: number): Observable<any> {
      let url: string = '' + this.appConstants.baseUrl + "DeleteSchoolStudentDetails" + '?childId=' + childId;
      return this.httpClient.Delete(url)
        .map(this.extractData)
        .catch(this.handleError);
    }


    //get semester for dropdown
    public getSemester(academicYearId): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataASemesterDropdown + '?schoolid=' + this.schoolId + '&academicYearId=' + academicYearId ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //get semester for dropdown
    public getSemesterT(selectedYear): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataASemesterDropdown + '?schoolid=' + this.schoolId + '&academicYearId=' + selectedYear ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //get year
    public getYear(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataAYearDropdown + '?schoolid=' + this.schoolId ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


    public getSchoolUsername(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      this.userId = this.localStorage.retrieve('id');
      let url: string = '' + this.appConstants.baseUrl + 'GetSchoolUserDetails' + '?schoolId=' + this.schoolId + '&userId=' + this.userId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }






    //get tests
    public getTest(SemesterId): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataATestDropdown + '?semesterid=' + SemesterId ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }
    //get tests
    public getTestT(selectedsemester): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataATestDropdown + '?semesterid=' + selectedsemester ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetSubjectsSectionInfo(SectionId,SubjectId,SemesterId): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSubjectsSectionInfo +
        '?sectionid=' + SectionId + '&subjectid=' + SubjectId + '&semesterid=' + SemesterId +
        '&iarr=' + this.arr1 + '&iarr=' + this.arr2 + '&iarr=' + this.arr3;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //get address
    public getSchoolDetailsForRC(StudentId,ChildTestMappingId): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let childTestMappingId = "";
        var counter = ChildTestMappingId.length;
        for(var i= 0; i< counter; i++ ){
        childTestMappingId += "&childtestIds=" + ChildTestMappingId[i]
        }
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSchoolDetailsForRC + '?schoolid=' + this.schoolId + '&Childid=' + StudentId + childTestMappingId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }





  getClassSummary(academicYearId: number, sectionId: number, testId: number): Observable<Blob> {
    const url = `${this.appConstants.baseUrl}DownloadClassMarksSummary?academicYearId=${academicYearId}&sectionId=${sectionId}&testId=${testId}`;
    return this.httpClient.FormPostBlob(url);
  }


  getClassSummaryDownload(academicYearId: number, standardId: number,sectionId: number): Observable<Blob> {
    const url = `${this.appConstants.baseUrl}DownloadClassListSummary?academicYearId=${academicYearId}&standardId=${standardId}&sectionId=${sectionId}`;
    return this.httpClient.FormPostBlob(url);
  }


  //get Acadamic Year
     public getAcadamicYearOfyears(): Observable<Response> {
       this.schoolId = this.localStorage.retrieve('SchoolId');
       let url: string = '' + this.appConstants.baseUrl + this.appConstants.DataAYearDropdown + '?schoolid=' + this.schoolId ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

     //post Acadamic Year
    public postAcadamicYear(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postAcadamicYear;
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //jaliya
    public postGradeLevel(Payload): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + 'SetGradeLevel';
      return this.httpClient.Post(url, Payload)
          .map(this.extractData)
          .catch(this.handleError)
  }



     //Update Academic Year
     public updateAcadamicYear(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UpdateAcadamicYear";
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }



  //Update Academic Year
  public updateCurrentYear(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "UpdateCurrentYear";
    return this.httpClient.Post(url, Payload)
      .map(this.extractData)
      .catch(this.handleError)
  }


    //get school Level
    public getLevel(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getLevels + '?SchoolId=' + this.schoolId;
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError);
    }



  public getPrompts(): Observable<Response> {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    let url: string = '' + this.appConstants.baseUrl + 'GetPromptsBySchoolId' + '?SchoolId=' + this.schoolId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }



  //get freeze details
  public getFreeze(academicYear, level, sem, test): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetFreezeDRCEnable' + '?academicYearId=' + academicYear + '&levelId=' + level + '&semesterId=' + sem + '&examId=' + test;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }



  //get school Grades
  public getGrades(): Observable<Response> {
    this.branchId = this.localStorage.retrieve('BranchId');
    let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetLevelStandardSectionMappingbyBrachId + '?branchId=' + this.branchId;
    // let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetstandardsectionMapping + '?SchoolId=' + this.schoolId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }



      //post school Level
      public postLevel(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postLevel;
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }


  public postPrompt(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'AddPromptToSchool';
    return this.httpClient.Post(url, Payload)
      .map(this.extractData)
      .catch(this.handleError)
  }



     //Update school Level
     public updateSLevel(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UpdateLevel";
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }


      //Update school Level
      public updatePropmt(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UpdateLevel";
        return this.httpClient.Post(url, Payload)
          .map(this.extractData)
          .catch(this.handleError)
      }

     //Update Subjects of addsubjects tab
     public updateLevel(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateLevel;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }
    //Delete Subjects of addsubjects tab
    public deleteLevel(Id): Observable<Response> {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.deleteLevel + '?id=' + Id;
        return this.httpClient.Delete(url)
            .map(this.extractData)
            .catch(this.handleError)
    }


    //teacher table api
    public GetSubjectsSemestersInfo(sectionid,subjectid,SemesterId): Observable<Response> {
        let semesterid = "";
        var counter = SemesterId.length;
        for(var i= 0; i< counter; i++ ){
            semesterid += "&semesters=" + SemesterId[i]
        }
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSubjectsSemestersInfo +
        '?sectionid=' + sectionid + '&subjectid=' + subjectid + '&Agrade=' + 80 +
        '&fail=' + 35 + semesterid;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //teacher get api
    public getTeacherDetails(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getTeacherDetails + '?schoolid=' + this.schoolId ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //teacher get api
    public getTeacherList(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + "GetTeacherDetails" + '?SchoolId=' + this.schoolId ;
        console.log(url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //teacher grade api
    public getTeacherStdSection(teacherid): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getTeacherStandardDropdown + '?TeacherId=' + teacherid ;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }
    //teacher Section api
    public getTeacherSection(teacherid,stdid): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getTeacherSectionDropdown + '?TeacherId=' + teacherid + '&stdid=' + stdid;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


     //teacher subjects api
    public getTeacherSubjects(sectionid,teacherid): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getTeacherSubjectDropdown + '?SectionId=' + sectionid + '&TeacherId=' + teacherid+ '&SchoolId=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


    //Students standard table api
    public getStudentsStandings(childid,subjectid,standardid,sectionid,SemesterId,flag): Observable<Response> {
        let semesterid = "";
        var counter = SemesterId.length;
        for(var i= 0; i< counter; i++ ){
            semesterid += "&semesters=" + SemesterId[i]
        }
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getStudentsStandings + '?childid=' + childid + '&subjectid=' + subjectid+ '&standardid=' + standardid
        + '&sectionid=' + sectionid + semesterid + '&flag=' + flag;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


    //posting Subjects of addsubjects tab
    public postSubject(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postSubject;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public postSubSubject(payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postSubSubject;
        return this.httpClient.Post(url, payload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public updateSubSubject(payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateSubSubject;
        return this.httpClient.Post(url, payload)
            .map(this.extractData)
            .catch(this.handleError)
    }


    //Get Subjects of addsubjects tab
    public getSubjectsOfSubjects(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSubjects + '?SchoolId=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }
    //Update Subjects of addsubjects tab
    public updateSubject(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateSubject;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }
    //Delete Subjects of addsubjects tab
    public DeleteSubjects(Id): Observable<Response> {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.deleteSubject + '?id=' + Id;
        return this.httpClient.Delete(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //posting SubjectsSectionMapping of addsubjects tab
    public PostSubjectSectionMapping(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "PostSubject";
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //get SubjectsSectionMapping of addsubjects tab
    public ShowSubjectSectionMappingaddsubject(selectedlevel,selectedGrade): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.showSubjectSectionMapping + '?SchoolId=' + this.schoolId + '&levelid=' + selectedlevel+ '&standardId=' + selectedGrade;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public showSubjectSectionMapping(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.showSubjectSectionMapping + '?SchoolId=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


    //posting Semester of addSemester tab
    public postSemester(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postSemesters;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Update Semester of addSemester tab
    public updateSemester(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateSemesters;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }
    //Delete Semester of addSemestertab
    public DeleteSemester(Id): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      var url: string = '' + this.appConstants.baseUrl + this.appConstants.removeSemester + '?semesterid=' + Id + '&schoolid=' + this.schoolId;
        return this.httpClient.Delete(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

  public DeleteParent(parentId,studentId): Observable<Response> {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    var url: string = '' + this.appConstants.baseUrl + 'DeleteParentDetails' + '?schoolId=' + this.schoolId + '&childId=' + studentId+ '&parentId=' + parentId;
    return this.httpClient.Delete(url)
      .map(this.extractData)
      .catch(this.handleError)
  }

    //posting Test of addTest tab
    public postTest(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.postSemesterTests;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Update Test of addTest tab
    public updateTest(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.updateSemesterTests;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }
    //Delete Test of addTest
    public DeleteTest(Id): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      var url: string = '' + this.appConstants.baseUrl + this.appConstants.removeSemesterTest + '?testid=' + Id + '&schoolid=' + this.schoolId;
        return this.httpClient.Delete(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //posting Test Mapping
    public postTestSectionsMapping(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.PostTestSectionsMapping;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get getSemesterTestMapping
    public getSemesterTestMapping(levelid: any): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSemesterTestMapping + '?SchoolId=' + this.schoolId + '&levelid='+levelid;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


    private extractData(res: Response) {
      let body = res.json();
      return body;
    }


  // private extractData1(res: Response) {
  //   console.log(res);
  //   // let body = res.json();
  //   // console.log(body);
  //   // return body;
  // }


    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        //let err = JSON.parse(error._body);
        return Observable.throw(errMsg);
    }

    public GetAveragePerformances(sectionid,testid,childid,academicYear): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getAveragePerformances + '?SectionId=' + sectionid + '&TestId=' + testid+ '&ChildId=' + childid + '&academicYear=' + academicYear;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

	public GetStudentsChartOverallPrecentageRank(childid): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetStudentsChartOverallPrecentageRank?childid=' + childid + '&schoolid=' + this.localStorage.retrieve('schoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetSubjectRankClassStudentCharts(childid, SubjectId): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetSubjectRankClassStudentCharts?childid=' + childid + '&SubjectId=' + SubjectId + '&schoolid=' + this.localStorage.retrieve('schoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetLevels(): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetLevels?schoolid=' + this.localStorage.retrieve('schoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetSubSubjects(subjectid): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetSubSubjects?SubjectID=' + subjectid;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetLevelStandardSectionMapping(lid): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetLevelStandardSectionMapping' + '?LevelId=' + lid + '&SchoolId=' + this.localStorage.retrieve('schoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetSubSubjectRankByClass(childid, SubjectId, SubSubjectId, LevelID, TestId): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetSubSubjectRankByClass?childid=' + childid + '&SubjectId=' + SubjectId + '&SubSubjectId=' + SubSubjectId + '&LevelID=' + LevelID + '&TestId=' + TestId + '&schoolid=' + this.localStorage.retrieve('schoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public GetCorrelationBetweenSubjects(SubjectId1, SubjectId2, GradeId, TestId): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + 'GetOverallTwoSubjectGradePrecentage?SubjectId1=' + SubjectId1 + '&SubjectId2=' + SubjectId2 + '&GradeId=' + GradeId + '&TestId=' + TestId;
        console.log(url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public getTeacherClassSubjectDetails(teacherid): Observable<Response> {
        let url: string = "" + this.appConstants.baseUrl + this.appConstants.GetTeacherClassSubjectList + "?TeacherId=" + teacherid;
        return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError);
    }

      //posting Subjects of addsubjects tab
    public postSchoolTeacherDetails(deptPayload): Observable<Response> {
        let url: string = "" + this.appConstants.baseUrl + "postSchoolTeacherDetails";
        return this.httpClient.Post(url, deptPayload)
          .map(this.extractData)
          .catch(this.handleError);
    }

    public postSubjectTeachers(deptPayload): Observable<Response> {
        let url: string = "" + this.appConstants.baseUrl + this.appConstants.AssignTeacherToSubject;
        return this.httpClient.Post(url, deptPayload)
          .map(this.extractData)
          .catch(this.handleError);
    }

    public GetOverallSubjectMarksOverallRankByGrade(subId, stdId, testId, academicYearId): Observable<Response> {
        let url: string = "" + this.appConstants.baseUrl + "GeOverallSubjectMarksOverallRankByGrade?SubjectId1=" + subId + "&GradeId=" + stdId + "&TestId=" + testId + "&AcademicYearId=" + academicYearId;
        return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError);
    }
    /*---------------------------------------------------------------------*/
    public getHigherEdChildNameList(course_id, batch_id): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + "GetHiEduChildInfoBySchoolCourseBatch" +'?Schoolid=' + this.schoolId + '&courseId=' + course_id +'&batchId=' + batch_id;
        console.log("getHigherEdChildNameList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get Course
    public getHigherEdChildCourseList(): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetCourseList" +'?Schoolid=' + /*this.schoolId*/1 ;
        console.log("getHigherEdChildCourseList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get semester
    public getHigherEdChildSemesterList(selectedCourse): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduSemester" +'?courseid=' + selectedCourse ;
        console.log("getHigherEdChildSemesterList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get Batch
    public getHigherEdChildBatchList(selectedCourse): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduBatchs" +'?courseid=' + selectedCourse ;
        console.log("getHigherEdChildBatchList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get exam
    public getHigherEdChildExamList(selectedCourse,selectedSemester): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetCourseSemesterexam" +'?courseid=' + selectedCourse +'&semesterId='+selectedSemester;
        console.log("getHigherEdChildBatchList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Post Exam
    public postHigherEduExam(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "PostCoursesemesterExam";
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }


    //Get Student details
    public getHiEduChildInfo(selectedCourse, selectedBatch): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduChildInfoBySchoolCourseBatch" +'?Schoolid=' + /*this.schoolId*/1 + '&courseId=' + selectedCourse +'&batchId=' + selectedBatch;
        console.log("GetHiEduChildInfoBySchoolCourseBatch", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get HigherEd DRC
    public getHiEduChildDRC(selectedCourse, selectedBatch,selectedinfo,selectedSemester,selectedExam): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduStudentsRC" +'?courseid=' + selectedCourse + '&batchid=' + selectedBatch +'&childid=' + selectedinfo + '&semeseterid=' + selectedSemester +'&examid=' + selectedExam;
        console.log("GetHiEduStudentsRC", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //Get Subject
   public getHigherEdChildSubjectList(selectedCourse,HselectedSemester,selectedExam): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetSemesterModule" +'?courseId=' + selectedCourse +'&semesterId=' + HselectedSemester +'&examId=' + selectedExam;
    console.log("getHigherEdChildSubjectList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
    }

    //Get grade level A,B,C
    public getGradeLevel(selectedlevel): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl +"GetLevelStandardSectionMapping"+'?SchoolId='+this.schoolId +'&LevelId=' + selectedlevel;
        console.log("GetLevelStandardSectionMapping", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
        }
    //Update grade level
     public updateGradeLevel(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UpdateGrade";
        return this.httpClient.Post(url, Payload)
            .map(this.extractData)
            .catch(this.handleError)
    }
      /*---------------------------Hiedu Chart ------------------------------------------*/

      //Get HiEduSubSubjectMarksForStudent

      public getHigherEdSubSubjectMarksList(selectedinfo,selectedmodule): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduSubSubjectMarksForStudent" +'?childId=' + selectedinfo +'&subjectId=' + selectedmodule ;
        console.log("getHigherEdSubSubjectMarksList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
        }

      //Get HiEduGetAllSubjectMarksForStudent

      public getHigherEdallsubjectMarksList(selectedinfo,selectedExam): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "HiEduGetAllSubjectMarksForStudent" +'?childId=' + selectedinfo +'&examId=' + selectedExam ;
        console.log("getHigherEdallsubjectMarksList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
        }


      //Get HiEduAverageSubjectMarks

      public getHigherEdAverageSubjectMarksList(selectedCourse,selectedBatch,HselectedSemester,selectedExam): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetHiEduAverageSubjectMarks" +'?courseId=' + selectedCourse +'&batchId=' + selectedBatch +'&semesterId=' + HselectedSemester  +'&examId=' + selectedExam;
        console.log("getHigherEdAverageSubjectMarksList", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
        }

    //Get HieduModuleStudentPerformanceScoreChart

      public getHigherEdModuleStudentPerformanceScoreList(selectedBatch,HselectedSemester,selectedExam,selectedmodule): Observable<any> {
        let url: string = '' + this.appConstants.baseUrl + "GetHieduModuleStudentPerformanceScoreChart" + '?batchId=' + selectedBatch +'&semesterId=' + HselectedSemester  +'&examId=' + selectedExam +'&subjectId=' + selectedmodule  ;
        console.log("getHigherEdModuleStudentPerformanceScoreList", url);
        return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
      }

    //post PostTeacherSubject
    public PostTeacherSubject(payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "PostTeacherSubject"
        url += `?TeacherId=${payload.TeacherId}&SubjectId=${payload.SubjectId}&SectionId=${payload.SectionId}&CreatedBy=${payload.CreatedBy}&ModifiedBy=${payload.ModifiedBy}&AcademicYearId=${payload.AcademicYearId}`;
        return this.httpClient.Post(url, payload)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public UploadExcelFile(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UploadExcelFile"
        return this.httpClient.PostFormDataOld(url, Payload)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public UploadCSVFile(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "UploadCSVFile"
        return this.httpClient.PostFormDataOld(url, Payload)
            .map(this.extractData)
            .catch(this.handleError);
    }




  public UploadDRCFileSubject(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "SubjectMarkUploadFile"
    return this.httpClient.PostFormDataOld(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public UploadDRCFileSubSubject(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "SubjectwithSubsubjectUploadFile"
    return this.httpClient.PostFormDataOld(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public UploadPDFFile(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "AddQuestionPaper"
    return this.httpClient.PostFormDataOld(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public StudentTeacherCommentUpload(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "StudentTeacherCommentUploadFile"
    return this.httpClient.PostFormDataOld(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public addSyllabusFile(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "AddSyllabus"
    return this.httpClient.PostFormDataOld(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public uploadSyllabusFile(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "Syllabus/UploadSyllabus"
    return this.httpClient.PostFormDataOld(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public UploadGeneratedPapers(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "AddGenerateQuestionPaper"
    return this.httpClient.Post(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }




  public modifyGeneratedQuestions(file: File, editType: string, lang: any): Observable<any> {
    const url = `${this.appConstants.baseUrl}ModifyGeneratedQuetions?editType=${encodeURIComponent(editType)}&lang=${encodeURIComponent(lang)}`;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.Post(url, formData).map(this.extractData)
      .catch(this.handleError);
  }


  public editImages(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "EditImage"
    return this.httpClient.Post(url, Payload)
      .map(this.extractData)
      .catch(this.handleError);
  }



  extractPdfFile(payload: any, code: string): Observable<any> {


    // The API endpoint URL with the code query parameter
    const url = `https://qipython.azurewebsites.net/api/pdf_extractor?code=${code}`;

    // Make the HTTP POST request
    return this.httpClient.PostPDFDataOld(url, payload)
      .map(this.extractData)
      .catch(this.handleError);
  }



  extractSyllabusFile(payload: any, code: string): Observable<any> {


    // The API endpoint URL with the code query parameter
    const url = `https://qipython.azurewebsites.net/api/syllabus_extractor?code=${code}`;

    // Make the HTTP POST request
    return this.httpClient.PostPDFDataOld(url, payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public generatePaperByPapers(payload, code): Observable<Response> {

    // The API endpoint URL with the code query parameter
    const url = `https://qipython.azurewebsites.net/api/generate_questions_papers?code=${code}`;


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public generatePaperByPapersCcode(payload, academicYearId, gradeId, subjectId, quetioncount, Lang): Observable<Response> {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    let url: string = '' + this.appConstants.baseUrl + "GenerateQuestions"
    url += `?schoolid=${this.schoolId}&academicYearId=${academicYearId}&gradeId=${gradeId}&subjectId=${subjectId}&quetioncount=${quetioncount}&Lang=${Lang}`;
    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public translateLanguage(payload): Observable<Response> {
    const updatedPayload = {
      QuetionContent: payload.QuetionContent,
      SchoolId: this.localStorage.retrieve('SchoolId'),
      SubjectId: payload.SubjectId,
      Lang: payload.Lang
    };
    let url: string = this.appConstants.baseUrl + "ConvertQues";
    return this.httpClient.Post(url, updatedPayload)
      .map(this.extractData)
      .catch(this.handleError);
  }



  public generatePaperBySyllabus(payload, code): Observable<Response> {

    // The API endpoint URL with the code query parameter
    const url = `https://qipython.azurewebsites.net/api/generate_questions_syllabus?code=${code}`;


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public generatePaperBySyllabusCcode(
    payload,
    prompt,
    academicYearId,
    gradeId,
    subjectId,
    Lang
  ): Observable<Response> {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    let url: string = `${this.appConstants.baseUrl}GenerateSyllabus`;

    // Correct order of parameters
    url += `?prompt=${prompt}&schoolid=${this.schoolId}&academicYearId=${1}&gradeId=${3429}&subjectId=${subjectId}&Lang=${Lang}`;

    return this.httpClient.Post(url, null) // Fixed "Post" to "post"
      .map(this.extractData)
      .catch(this.handleError);
  }


  public generatePaperBySyllabusCcodeNew(payload): Observable<Response> {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    let url: string = `${this.appConstants.baseUrl}Syllabus/GenerateQuestions`;
    return this.httpClient.Post(url, payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public filterPaper(payload, code): Observable<Response> {

    // The API endpoint URL with the code query parameter
    const url = `https://qipython.azurewebsites.net/api/filter_questions2?code=${code}`;


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }



  public studentPromotion(payload): Observable<Response> {

    this.token = this.localStorage.retrieve('token');

    let url: string = '' + this.appConstants.baseUrl + "PromoteStudentGradeSection" + '?token=' +  this.token;


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }




  public studentBulkInactive(payload): Observable<Response> {

    // this.token = this.localStorage.retrieve('token');

    let url: string = '' + this.appConstants.baseUrl + "UpdateBulkStudentInactiveStatus";


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public studentBulkDeletion(payload): Observable<Response> {

    // this.token = this.localStorage.retrieve('token');

    let url: string = '' + this.appConstants.baseUrl + "BulkDeleteSchoolStudentDetails";


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public deleteParent(childId, parentId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl
      + 'DeleteParentDetails' + '?schoolId=' +this.schoolId +'&childId=' + childId +'&parentId=' + parentId;
    return this.httpClient.Delete(url)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public studentPromotionQuanta(payload): Observable<Response> {

    this.token = this.localStorage.retrieve('token');

    let url: string = '' + this.appConstants.baseUrl + "PromoteStudentGradeSection" + '?token=' +  this.localStorage.retrieve('auth_token');


    return this.httpClient.Post(url, payload,)
      .map(this.extractData)
      .catch(this.handleError);
  }





  public StudentRegisterUploadXMLFile(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "StudentRegisterUploadXMLFile"
        return this.httpClient.PostFormDataOld(url, Payload)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public StudentRegisterUploadCSVFile(Payload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "StudentRegisterUploadCSVFile"
        return this.httpClient.PostFormDataOld(url, Payload)
            .map(this.extractData)
            .catch(this.handleError);
    }


    //teachers list dropdown api
    public getDropDownTeacherDetails(): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetDropDownTeacherDetails" + '?branchId=' +  this.branchId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //teachers table
    public getTeacherDetailsForSection(selectedYear,selectedsec ): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + "GetTeacherDetailsForSection" +'?academicYearId=' + selectedYear  +'&sectionId=' + selectedsec;
        console.log("getTeacherDetailsForSection", url);
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    //post PostSubjectTestMapping
    public PostSubjectTestMapping(payload): Observable<Response> {
        let url: string = "" + this.appConstants.baseUrl + "PostSubjectTestMapping";
        return this.httpClient.Post(url, payload)
          .map(this.extractData)
          .catch(this.handleError);
    }



  public FreezeDRC(payload): Observable<Response> {
    let url: string = "" + this.appConstants.baseUrl + "AddFreezeDRCEnable";
    return this.httpClient.Post(url, payload)
      .map(this.extractData)
      .catch(this.handleError);
  }




  //post parent access control
  public ParentAccessControl(payload): Observable<Response> {
    let url: string = "" + this.appConstants.baseUrl + "UpdateDrcEnable";
    return this.httpClient.Post(url, payload)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public getQuestionPapers(academicYearId,gradeId,subjectId,semesterId,examId,type): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetQuestionPapers"
      +'?academicYearId=' + academicYearId
      +'&gradeId=' + gradeId
      +'&subjectId=' + subjectId
      +'&semesterId=' + semesterId
      +'&examId=' + examId
      +'&QuestionPaperTypeId=' + type;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }


  public getGeneratedPapers(academicYearIdFrom, academicYearIdTo, gradeId,subjectId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetGenerateQuestionPapers"
      +'?academicYearfromId=' + academicYearIdFrom
      +'&academicYeartoId=' + academicYearIdTo
      +'&gradeId=' + gradeId
      +'&subjectId=' + subjectId;

    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }



  public getSyllabus(gradeId,subjectId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetSyllabus"
      +'?gradeId=' + gradeId
      +'&subjectId=' + subjectId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }




  public getQuestionPDF(paperId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetOneQuestionPapers"
      +'?Id=' + paperId;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }


  public deletePaper(question: any): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "BulkDeleteQuestionPaper";
    return this.httpClient.Put(url, question,)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public deleteGeneratedPaper(question: any): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "BulkDeleteGenerateQuetionPapers";
    return this.httpClient.Put(url, question,)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteSyllabus(syllabus: any): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "BulkDeleteSyllabus";
    return this.httpClient.Put(url, syllabus,)
      .map(this.extractData)
      .catch(this.handleError);
  }




}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/dataAnalytics/dataAnalytics.service.ts